// extracted by mini-css-extract-plugin
module.exports = {"title":"a10a3f92e9--title--lLcZo"};